class autoriz {
  constructor(coment, comentId, from, empId, date, to) {
    let horaFrom;
    let minFrom;
    if (from < 0) {
      let realValue = (720 + from) + 720;
      horaFrom = -Math.floor(realValue / 60);
      minFrom = (realValue - (-horaFrom * 60));
    
    } else if (from > 1440) {
      let fromFormat = from - 1440;
      horaFrom = Math.floor(fromFormat / 60);
      minFrom = Math.floor(horaFrom * 60);
      minFrom = fromFormat - minFrom;

      if (horaFrom < 10) {
        horaFrom = '0' + horaFrom;
      }

      horaFrom = '+' + horaFrom;
    } else {

      horaFrom = Math.floor(from / 60);
      minFrom = Math.floor(horaFrom * 60);
      minFrom = from - minFrom;
      if (horaFrom < 10) {
        horaFrom = '0' + horaFrom;
      }
    }
  
    minFrom = minFrom < 10 ? "0" + minFrom : minFrom;

    let horaTo;
    let minTo;
    let toFormat = to;
    if (to < 0) {
      let realValue = (720 + to) + 720;
      horaTo = -Math.floor(realValue / 60);
      minTo = (realValue - (-horaTo * 60));
    } else if (toFormat > 1440) {
      toFormat = toFormat - 1440;
      horaTo = Math.floor(toFormat / 60);
      minTo = Math.floor(horaTo * 60);
      minTo = toFormat - minTo;

      if (horaTo < 10) {
        horaTo = '0' + horaTo;
      }

      horaTo = '+' + horaTo;
    } else {
      horaTo = Math.floor(to / 60);
      minTo = Math.floor(horaTo * 60);
      minTo = to - minTo;
    
      if (horaTo < 10) {
        horaTo = '0' + horaTo;
      }
    }

    minTo = minTo < 10 ? "0" + minTo : minTo;

    this.coment = coment;
    this.comentId = comentId;
    this.from = horaFrom + ":" + minFrom;
    this.empId = empId;
    this.date = date;
    this.to = horaTo + ":" + minTo;
    this.originalTo = to;
    this.originalFrom = from;

  }
  static fromJson({ Coment, ComentId, Desde, EmpId, Fecha, Hasta }) {
    return new autoriz(Coment, ComentId, Desde, EmpId, Fecha, Hasta);
  }
}
export default autoriz;
